import { Component, AfterViewInit, ViewChild } from '@angular/core';
import merge from 'lodash-es/merge';
import { FCSFormService } from '../services/FCSForm.service';
import { MatHorizontalStepper, MatStepper } from '@angular/material/stepper';
import { MatDialog } from '@angular/material/dialog';
import { ProgressComponent } from '../components/dialog/progress/progress.component';
import { SuccessComponent } from '../components/dialog/success/success.component';
import { Router } from '@angular/router';
import { AppInsightsService } from '../services/app-insights.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit {
  //events of forms
  clientFormEvent: boolean;
  childAbuseFormEvent: boolean;
  childrenFormEvent: boolean;
  maritalFormEvent: boolean;
  movingPartyFormEvent: boolean;
  domesticViolenceFormEvent: boolean;
  psychologicalAbuseFormEvent: boolean;
  physicalViolenceFormEvent: boolean;
  signatureFormEvent: boolean;
  //event of data of forms
  clientData: any;
  childAbuseData: any;
  childrenData: any;
  maritalData: any;
  movingPartyData: any;
  domesticViolenceData: any;
  psychologicalAbuseData: any;
  physicalViolenceData: any;
  signatureData: any = {
    PrintName: '',
    Signature: '',
    email: '',
    Initial: '',
    DateSign: '',
    AdditionalInfo1: '',
    AdditionalInfo2: '',
    AdditionalInfo3: '',
    AdditionalInfo4: ''
  };
  // clientEmail
  clientEmail: string;
  signatureEmail: string;
  enableEmailSubmit: boolean = false;
  @ViewChild(MatHorizontalStepper, { static: false }) stepper: MatHorizontalStepper;

  private lastValidationState = {
    hasValidSignature: false,
    signatureFormEvent: false,
    enableEmailSubmit: false,
    hasEmail: false,
    printName: '',
    signature: ''
  };

  constructor(private fcsFormService: FCSFormService, public dialog: MatDialog,
    private router: Router, private appInsightsService: AppInsightsService) {
  }

  /**
   * send information to backend
   */
  submit() {
    // Verify signature data is present before proceeding
    if (!this.signatureData.PrintName || !this.signatureData.Signature) {
      this.appInsightsService.logTrace('Form Submission - Missing Signature Data', {
        hasSignatureData: !!this.signatureData,
        printName: this.signatureData.PrintName,
        signature: this.signatureData.Signature
      });
      return;
    }

    this.dialog.open(ProgressComponent, { disableClose: true });
    let data = merge(this.clientData, this.childAbuseData,
      { "children": this.childrenData }, this.maritalData, this.domesticViolenceData, this.movingPartyData,
      this.psychologicalAbuseData, this.physicalViolenceData, this.signatureData);

    // Verify the merged data has the required fields
    if (!data.PrintName || !data.Signature) {
      this.appInsightsService.logTrace('Form Submission - Data Merge Issue', {
        printName: data.PrintName,
        signature: data.Signature,
        originalPrintName: this.signatureData.PrintName,
        originalSignature: this.signatureData.Signature
      });
      this.dialog.closeAll();
      return;
    }

    this.fcsFormService.saveForm(data).subscribe((res) => {
      this.dialog.closeAll();
      this.dialog.open(SuccessComponent, { disableClose: true });
    }, (err) => {
      this.router.navigate(['/error', err.status]);
      this.dialog.closeAll();
    })
  }

  onNextStep(stepper: MatStepper) {
    window.scrollTo(0, 0)
    stepper.next();
  }

  enableNextStep(currentStep) {
    if (currentStep == 0) { // information
      return this._validPage1();
    } else if (currentStep === 1) { // client information
      return this._validPage2();
    } else if (currentStep === 2) { // child abuse 
      return this._validPage3();
    } else if (currentStep === 3) { // domestic violence
      return this._validPage4();
    } else if (currentStep === 4) { // psychological abuse
      return this._validPage5();
    } else if (currentStep === 5) { // physical abuse
      return this._validPage6();
    }
  }
  enableEmailSubmitButton() {
    const hasValidSignature = this.signatureData && 
                            this.signatureData.PrintName && 
                            this.signatureData.PrintName.trim() !== '' &&
                            this.signatureData.Signature && 
                            this.signatureData.Signature.trim() !== '';
    
    const currentState = {
      hasValidSignature,
      signatureFormEvent: this._validPage7(),
      enableEmailSubmit: this.enableEmailSubmit,
      hasEmail: this.signatureData.email.length > 0,
      printName: this.signatureData.PrintName || '',
      signature: this.signatureData.Signature || ''
    };

    return this._validPage7() && 
           this.enableEmailSubmit && 
           this.signatureData.email.length > 0 &&
           hasValidSignature;
  }
  ngAfterViewInit() {
    this.stepper._getIndicatorType = () => 'number';
  }
  _validPage1(): boolean {
    return true;
  }
  _validPage2(): boolean {
    return this.clientFormEvent && this.maritalFormEvent && this.childrenFormEvent
      && this.childrenData && this.childrenData.length > 0 && this.movingPartyFormEvent;
  }
  _validPage3(): boolean {
    return this.childAbuseFormEvent;
  }
  _validPage4(): boolean {
    return this.domesticViolenceFormEvent;
  }
  _validPage5(): boolean {
    return this.psychologicalAbuseFormEvent;
  }
  _validPage6(): boolean {
    return this.physicalViolenceFormEvent;
  }
  _validPage7(): boolean {
    return this.signatureFormEvent;
  }
  onClientChange(_clientEvent) {
    this.clientFormEvent = _clientEvent;
  }
  onChildAbuseChange(_childEvent) {
    this.childAbuseFormEvent = _childEvent;
  }
  onChildrenChange(_childrenEvent) {
    this.childrenFormEvent = _childrenEvent;
  }
  onMaritalChange(_maritalEvent) {
    this.maritalFormEvent = _maritalEvent;
  }
  onMovingPartyChange(_movingPartyEvent) {
    this.movingPartyFormEvent = _movingPartyEvent;
  }
  onDomesticViolenceChange(_domesticAbuseEvent) {
    this.domesticViolenceFormEvent = _domesticAbuseEvent;
  }
  onPsychologicalAbuseChange(_psychologicalAbuseEvent) {
    this.psychologicalAbuseFormEvent = _psychologicalAbuseEvent;
  }
  onPhysicalViolenceChange(_physicalViolenceEvent) {
    this.physicalViolenceFormEvent = _physicalViolenceEvent;
  }
  onSignatureChange(_signatureEvent) {
    this.signatureFormEvent = _signatureEvent;
  }
  onClientData(data) {
    this.clientData = data;
    this.clientEmail = data.email;
  }
  onChildAbuseData(data) {
    this.childAbuseData = data;
  }
  onChildrenData(data) {
    this.childrenData = data;
  }
  onMaritalData(data) {
    this.maritalData = data;
  }
  onDomesticViolenceData(data) {
    this.domesticViolenceData = data;
  }
  onPsychologicalAbuseData(data) {
    this.psychologicalAbuseData = data;
  }
  onPhysicalViolenceData(data) {
    this.physicalViolenceData = data;
  }
  onSignatureData(data) {
    this.signatureData = data;
    this.signatureEmail = data.email;
  }
  onValidEmail(data) {
    this.enableEmailSubmit = data;
  }
  onMovingPartyData(data) {
    this.movingPartyData = data;
  }
}
